import { useEffect, useState } from 'react'
import { Dropdown, Form, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import CustomToggle from '../../../../components/dropdowns'
import "react-responsive-carousel/lib/styles/carousel.min.css"
//image
import user01 from '../../../../assets/images/user/01.jpg'
import axios from 'axios'
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom'
import * as moment from 'moment'
import CarouselN from 'react-bootstrap/Carousel';
import ShareOffcanvas from '../../../../components/share-offcanvas'
import icon1 from '../../../../assets/images/icon/01.png'

import { getToken } from '../../../../utils/auth'
import Card from '../../../../components/Card'
import { useTranslation } from 'react-i18next'
import { MdOutlineDone } from "react-icons/md"
import { useUser } from '../../../../Context/UserContext'
import ShareToFeedPopup from './ShareToFeedPopup'
import { AiOutlineSend } from "react-icons/ai";


const GroupCardBody = ({ data, index, handleAllPost }) => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
      const { userData } = useUser();

    useEffect(() => {
        if (!getToken()) {
            navigate("/auth/sign-in")
        }
    }, []);
    const [content, setContent] = useState(null);
    const [comments, setComments] = useState(null);
    const [show, setShow] = useState(null);
    const [qrPopupOpen, setQrPopupOpen] = useState(false);
    const [qrImageUrl, setQrImageUrl] = useState('');
    const [expandedRows, setExpandedRows] = useState({});
    const [like, setLike] = useState(false);
    const [likeCounts, setLikeCounts] = useState(0);
    const [reportModalOpen, setReportModalOpen] = useState(false);
    const [reportDescription, setReportDescription] = useState("");
    const [reportId, setReportId] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [feedData, setFeedData] = useState("");

    const handleReportClick = (reqid) => {
        setReportId(reqid);
        setReportModalOpen(true);
    };
    const closeReportModal = () => {
        setReportModalOpen(false);
    };
    const handleReport = async () => {
        if (!reportDescription) {
            toast.error("Report issue is required");
            return;
        }
        try {
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/report`,
                {
                    reportFor: "post",
                    issueDescription: reportDescription,
                    userId: "",
                    postId: data?._id,
                    eventId: "",
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            closeReportModal();
            setReportId("");
            setReportDescription("");
            toast.success(response.data.message);

        } catch (error) {
            setReportId("");
            setReportDescription("");
            toast.error(error?.response?.data?.message || "Failed Reporting Post");
        }
    };

    const toggleExpand = (index) => {
        setExpandedRows((prevExpandedRows) => ({
            ...prevExpandedRows,
            [index]: !prevExpandedRows[index],
        }));
    };

    const handleQrClick = (imageUrl) => {
        setQrImageUrl(imageUrl);
        setQrPopupOpen(true);
    };

    const downloadQR = async () => {
        if (!qrImageUrl?.qrCodeUrl || !qrImageUrl?.postUID) return;
      
        const image = new Image();
        image.crossOrigin = 'Anonymous'; // Prevent CORS issues
        image.src = qrImageUrl.qrCodeUrl;
      
        image.onload = () => {
          const padding = 70; // Extra space for UID + website + margin
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
      
          canvas.width = image.width;
          canvas.height = image.height + padding;
      
          // Set white background
          ctx.fillStyle = "white";
          ctx.fillRect(0, 0, canvas.width, canvas.height);
      
          // Draw the QR image
          ctx.drawImage(image, 0, 0);
      
          // UID: Bold and 18px
          ctx.fillStyle = "black";
          ctx.textAlign = "center";
          ctx.font = "bold 18px Arial";
          ctx.fillText(qrImageUrl.postUID, canvas.width / 2, image.height + 20);
      
          // Website: Normal and 10px
          ctx.font = "normal 10px Arial";
          ctx.fillText("www.dirido.com", canvas.width / 2, image.height + 40);
      
          // Create and trigger download
          const link = document.createElement("a");
          link.href = canvas.toDataURL("image/png");
          link.download = `QR_${qrImageUrl.postUID}.png`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        };
      };
      
      
      
    const closeQrPopup = () => {
        setQrPopupOpen(false);
    };
    const renderDescription = (data, index) => {
        const description = data?.description;
        const threshold = 180;

        if (description && description.length > threshold) {
            if (expandedRows[index]) {
                return (
                    <div>
                        <div dangerouslySetInnerHTML={{ __html: description }} />
                        <button onClick={() => toggleExpand(index)} style={{ color: "#FF5500", background: "none", border: "none", cursor: "pointer", display: "block" }}>Show Less...</button>
                    </div>
                );
            } else {
                return (
                    <div>
                        <div style={{ display: "inline" }} dangerouslySetInnerHTML={{ __html: `${description.slice(0, threshold)}...` }} />
                        <button onClick={() => toggleExpand(index)} style={{ color: "#FF5500", background: "none", border: "none", cursor: "pointer", display: "inline" }}>Show More...</button>
                    </div>
                );
            }
        } else {
            return <div dangerouslySetInnerHTML={{ __html: description }} />;
        }
    };

    useEffect(() => {
        handleGetComments();
    }, [])
    const handleGetComments = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/post/comment/${data?._id}`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            }
            )
            setComments(response?.data?.data);
        } catch (error) {
            console.log("Failed Fetching Devices", error);
        }
    }
    const handleChange = (e, index) => {
        setContent(e.target.value)
    }
    const [loadingComment, setLoadingComment] = useState(false);

    const handleAddComments = async (e, id) => {
        e.preventDefault();
        try {
            setLoadingComment(true); 

            const dataToSent = {
                "content": content,
                "attachmentLink": ''
            }
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/post/comment/${id}`,
                dataToSent, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
            );
            // toast.success(response?.data?.message);
            setContent('');
            handleGetComments(id);
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }finally {
            setLoadingComment(false);
        }
    }
    useEffect(() => {
        const a =data?.likes?.find((i)=>i===data?.userId?._id)
        if (like) {
            setLikeCounts(data?.likes?.length + 1)
        }
    }, [like])
    useEffect(() => {
        setLikeCounts(data?.likes?.length)
    }, [])
    const handleAddLikes = async (e, id, flag) => {
        e.preventDefault();
        try {

            const dataToSent = {
                "addLike": flag
            }
            const token = getToken();
            const response = await axios.put(
                `${process.env.REACT_APP_URL}/api/post/like-status/${id}`,
                dataToSent, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
            );
            handleAllPost();
            // setLike(false);
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    const handleSavePost = async (postID) => {
        try {
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/post/save/${postID}`, {}, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    // "Content-Type": "multipart/form-data"
                }
            }
            )
            toast.success(response.data.message)
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed Saving Post");
        }
    }
    const handleNavigateProfile = (data) => {
        if (data?.selfCreated) {
            navigate('/myprofile');
        } else {
            navigate(`/userprofile/${data?.userId?.UID}`);
        }
    };
    const [deleteId, setDeleteId] = useState("");
    const [showDelete, setShowDelete] = useState(false);
    const handleCloseDelete = () => {
        setShowDelete(false)
        setDeleteId("");
    };
    const handleShowDelete = (contactid) => {
      setDeleteId(contactid);
      setShowDelete(true);
    };
  
    const handleDeletePost = async () => {
      if (!deleteId) {
        toast.error("Please try later");
      }
      try {
        const token = getToken();
        const response = await axios.delete(
          `${process.env.REACT_APP_URL}/api/post/${deleteId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // setPage(1);
        handleAllPost(true);
        setDeleteId("");
        handleCloseDelete();
        // console.log("Post Deleted Successfully");
        toast.success("Post deleted successfully");
      } catch (error) {
        console.error("Failed ", error);
        toast.error(error?.response?.data?.message || "Failed to delete Contact");
      }
    };

    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => {
        setShowEdit(false);
        setDescription("");
        setSelectedFile([]);
        setPhotos([]);
        setImagePreview([]);}
    const handleShowEdit = () => setShowEdit(true);
    const [description, setDescription] = useState("");
    const [selectedFile, setSelectedFile] = useState([]);
    const [imagePreview, setImagePreview] = useState([]);
    const [categorypost, setCategorypost] = useState("public");
    const [photos, setPhotos] = useState([]);
    const [postId, setPostId] = useState(null);
    const handleCategoryChange = (e) => {
        setCategorypost(e.target.value);
    };


  
    const handleFileInputChange = (event) => {
        const files = Array.from(event.target.files);
        
        setSelectedFile(prevFiles => [...prevFiles, ...files]); // Store new binary files only
    
        const previews = files.map(file => URL.createObjectURL(file));
        setImagePreview(prev => [...prev, ...previews]); // Update preview for UI
        toast.success("File selected!");
    };
    
    const handleEditClick = (data) => {
        setPostId(data._id);
        setDescription(data?.description || '');
        setPhotos(data?.photos || []); // Old image URLs
        setSelectedFile([]); // Reset new file uploads
        setImagePreview(data?.photos || []); // Show old images in UI
        setShowEdit(true);
    };
    
    // Handle Image Removal
    const handleRemoveImage = (index) => {
        if (imagePreview[index].startsWith("http")) {
            // It's an old image URL, remove from 'photos'
            setPhotos(prev => prev.filter((_, i) => i !== index));
        } else {
            // It's a newly uploaded file, remove from 'selectedFile'
            setSelectedFile(prev => prev.filter((_, i) => i !== index));
        }
    
        setImagePreview(prev => prev.filter((_, i) => i !== index)); // Remove from UI preview
    };
    
    const handlePost = async () => {
        if (!description) {
            toast.error("Description is required");
            return;
        }
    
        try {
            const formData = new FormData();
            const token = getToken();
            // Upload only new files
            for (let i = 0; i < selectedFile.length; i++) {
                formData.append('files', selectedFile[i]);
            }
    
            let uploadedPhotos = [];
            if (selectedFile.length > 0) {
                const uploadResponse = await axios.post(
                    `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${token}`,
                        },
                    }
                );
                uploadedPhotos = uploadResponse.data.data;
            }
    
            postPhoto(uploadedPhotos);
        } catch (error) {
            console.log("Failed to create post:", error);
            toast.error(error?.response?.data?.message || "Failed to upload images/videos");
        }
    };
    
    const postPhoto = async (newUploadedPhotos) => {
        if (!description) {
            toast.error("Description is required");
            return;
        }
    
        try {
            const token = getToken();
            const postData = {
                description: description,
                photos: [...photos, ...newUploadedPhotos], // Merge old and new images
                // postType: categorypost,
            };
    
            const postResponse = await axios.put(
                `${process.env.REACT_APP_URL}/api/post/${postId}`,
                postData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );
            // setPage(1);
            handleAllPost(true);
            // console.log("Post Updated Successfully", postResponse.data);
            toast.success("Post updated successfully");
    
            // Reset State
            setDescription("");
            setSelectedFile([]);
            setPhotos([]);
            setImagePreview([]);
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to update post");
            console.log("Failed Posting ", error);
        } finally {
            setShowEdit(false);
        }
    };


    const handleCopyUrl = (postId) => {
        const url = `${process.env.REACT_APP_URL_POST}/post/${postId}`;
        navigator.clipboard.writeText(url).then(() => {
        toast.success("URL Copied")
        }).catch(err => {
          console.error('Could not copy text: ', err);
        });
      };

      const handlePostFeed = (data) => {
        setShowPopup(true)
        setFeedData(data)
      }
    return (
        <>
<Toaster position="top-right" reverseOrder={false}/>
<Card.Body>
                <div className="post-item">
                    <div className="user-post-data py-3">
                        <div className="d-flex justify-content-between">
                            <div className=" me-3">
                                <img className="rounded-circle img-fluid" style={{ width: "50px" }} src={data?.userId?.profileImageLink ? data?.userId?.profileImageLink : "/profile.png"} alt="Img" />
                            </div>
                            <div className="w-100">
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <h5 className="mb-0 d-inline-block text-primary"  style={{ cursor: "pointer" }} onClick={() => handleNavigateProfile(data)}>{data?.userId?.firstName} {data?.userId?.lastName}</h5> {!data?.selfCreated && <>{t("resharedPost")}</>}
                                        <p className="mb-0 " style={{ textTransform: "capitalize" }}>{moment(data?.createdAt).fromNow()}</p>
                                    </div>
                                    <div
                                        className="card-post-toolbar"
                                        style={{ display: "flex" }}
                                    >
                                        {data?.qrCodeUrl ? (
                                            <div>
                                                <img
                                                    src={data?.qrCodeUrl}
                                                    onClick={() =>
                                                        handleQrClick(data)
                                                    }
                                                    style={{
                                                        width: "50px",
                                                        height: "50px",
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <div></div>
                                        )}
                                        <Dropdown>
                                            <Dropdown.Toggle variant="bg-transparent">
                                                <span className="material-symbols-outlined">
                                                    more_horiz
                                                </span>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="dropdown-menu m-0 p-0">
                                            {/* {!data?.selfCreated && ( */}
                                                <Dropdown.Item
                                                    className=" p-3"
                                                    to="#"
                                                    onClick={() => handleSavePost(data._id)}
                                                >
                                                    <div className="d-flex align-items-top">
                                                        <div className="h4 material-symbols-outlined">
                                                            <i className="ri-save-line"></i>
                                                        </div>

                                                        <div className="data ms-2">
                                                            <h6>{t('save_post')}</h6>
                                                            <p className="mb-0">{t('add_to_saved_items')}</p>
                                                        </div>
                                                    </div>
                                                </Dropdown.Item>
                                            {/* )} */}
                                                {!data?.selfCreated && (
                                                <Dropdown.Item
                                                    className="p-3"
                                                    onClick={() => handleReportClick(data._id)}
                                                >
                                                    <div className="d-flex align-items-top">
                                                        <div className="h4 material-symbols-outlined">
                                                            <i className="ri-close-circle-line h4"></i>
                                                        </div>{" "}
                                                        <div className="data ms-2">
                                                            <h6>{t('reportPost')}</h6>
                                                            <p className="mb-0">
                                                            {t('reportThisPost')}
                                                            </p>
                                                        </div>
                                                    </div>

                                                </Dropdown.Item>

                                            )}
                                            {data?.selfCreated && (
                                               <Dropdown.Item className="p-3" to="#" 
                                                                                      onClick={() => handleEditClick(data)}
                                                                                      >
                                                      <div className="d-flex align-items-top">
                                                        <a style={{color:"black"}}
                                                                      href="#"
                                                                      className="material-symbols-outlined"
                                                                    >
                                                                      edit
                                                                    </a>
                                                        <div className="data ms-2" >
                                                          <h6>{t('edit')} {t('post')}</h6>
                                                          <p className="mb-0">{t('update_post_details')}</p>
                                                        </div>
                                                      </div>
                                                    </Dropdown.Item>)}
                                             {data?.selfCreated && (
                                            
                                                                                      <Dropdown.Item className="p-3" to="#" 
                                                                                      onClick={() => handleShowDelete(data?._id)}
                                                                                      >
                                                      <div className="d-flex align-items-top">
                                                        <a style={{color:"black"}}
                                                                      href="#"
                                                                      className="material-symbols-outlined"
                                                                    >
                                                                      delete
                                                                    </a>
                                                        <div className="data ms-2" >
                                                          <h6>{t('delete')} {t('post')}</h6>
                                                          <p className="mb-0">{t('delete_the_post')}</p>
                                                        </div>
                                                      </div>
                                                    </Dropdown.Item>)}
                                                    <Dropdown.Item className="p-3" to="#" onClick={() => handleCopyUrl(data?._id)}>
          <div className="d-flex align-items-top">
            <i className="ri-link h4"></i>
            <div className="data ms-2">
              <h6>{t('copy_url')}</h6>
              <p className="mb-0">{t('copy_post_url_to_clipboard')}</p>
            </div>
          </div>
        </Dropdown.Item>
        <Dropdown.Item className="p-3" to="#" 
        onClick={() => handlePostFeed(data)}
        >
          <div className="d-flex align-items-top">
            <i className="ri-notification-line h4"></i>
            <div className="data ms-2">
              <h6>{t('shareToFeed')}</h6>
              <p className="mb-0">{t('spreadToFeed')}</p>
            </div>
          </div>
        </Dropdown.Item>
                                                {/* <Dropdown.Item className=" p-3" to="#">
                                                    <div className="d-flex align-items-top">
                                                        <i className="ri-user-unfollow-line h4"></i>
                                                        <div className="data ms-2">
                                                            <h6>Unfollow User</h6>
                                                            <p className="mb-0">
                                                                Stop seeing posts but stay
                                                                friends
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Dropdown.Item> */}
                                                {/* <Dropdown.Item className=" p-3" to="#">
                                                <div className="d-flex align-items-top">
                                                    <i className="ri-notification-line h4"></i>
                                                    <div className="data ms-2">
                                                        <h6>Share to Group</h6>
                                                        <p className="mb-0">Spread this post to your groups</p>
                                                    </div>
                                                </div>
                                            </Dropdown.Item> */}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-3">
                        <p>{renderDescription(data, index)}</p>
                    </div>
                    <div className="user-post">
                        <CarouselN style={{ maxWidth: '600px', margin: '0 auto' }}>
                            {data?.photos?.map((photo, photoIndex) => (
                                // <CarouselN.Item key={photoIndex}>
                                //     <img
                                //         className="d-block w-100"
                                //         src={photo}
                                //         alt={`post-photo-${photoIndex}`}
                                //         style={{
                                //             width: '100%',
                                //             height: 'auto',
                                //             objectFit: 'cover',
                                //             borderRadius: '8px',
                                //         }}
                                //     />
                                // </CarouselN.Item>
                                <CarouselN.Item key={photoIndex}>
                                {photo?.endsWith('.mp4') || photo?.endsWith('.mov') ? (
                                    <video
                                        className="d-block w-100"
                                        controls
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            maxHeight:"50vh",
                                            borderRadius: '8px',
                                        }}
                                    >
                                        <source src={photo} type="video/mp4" />
                                        <source src={photo} type="video/quicktime" />
                                        Your browser does not support the video tag.
                                    </video>
                                ) : (
                                    <img
                                        className="d-block w-100"
                                        src={photo}
                                        alt={`post-photo-${photoIndex}`}
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            maxHeight:"50vh",
                                            objectFit: 'cover',
                                            borderRadius: '8px',
                                        }}
                                    />
                                )}
                            </CarouselN.Item>
                            ))}
                        </CarouselN>
                    </div>
                    {/* <div className="user-post">
                        <img className="img-fluid w-100" src={data?.photos[0]}  alt="postimage"/>
                </div> */}
                    <div className="comment-area mt-3">
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                            <div className="like-block position-relative d-flex align-items-center">
                                <div className="d-flex align-items-center">
                                    <div className="like-data">
                                    <Dropdown>
                                        <div>
                                            <img src={icon1} className="img-fluid" alt="" onClick={(e) => { handleAddLikes(e, data?._id, true); setLike(!like) }}/>

                                        </div>
                                        {/* <Dropdown.Menu className=" py-2" onClick={(e) => { handleAddLikes(e, data?._id, true); setLike(!like) }}>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Like</Tooltip>} className="ms-2 me-2" >{like ? <AiFillLike color="blue" className="img-fluid me-2 " size="25" /> : <AiOutlineLike color="blue" className="img-fluid me-2 " size="25" />}</OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Love</Tooltip>} className="me-2" ><img src={icon2} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Happy</Tooltip>} className="me-2" ><img src={icon3} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>HaHa</Tooltip>} className="me-2" ><img src={icon4} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Think</Tooltip>} className="me-2" ><img src={icon5} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Sade</Tooltip>} className="me-2" ><img src={icon6} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Lovely</Tooltip>} className="me-2" ><img src={icon7} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                        </Dropdown.Menu> */}
                                    </Dropdown>
                                    </div>
                                    <div className="total-like-block ms-2 me-3">
                                        <Dropdown>

                                        <div  id="post-option" style={{color:"black"}}>
                                            {likeCounts} {data?.likes?.length > 1 ? t("likes") : t("like")}
                                        </div>
                                            {/* <Dropdown.Menu className="dropdown-menu">
                                                <Dropdown.Item className="dropdown-item" href="#">Max Emum</Dropdown.Item>
                                                <Dropdown.Item className="dropdown-item" href="#">Bill Yerds</Dropdown.Item>
                                                <Dropdown.Item className="dropdown-item" href="#">Hap E. Birthday</Dropdown.Item>
                                                <Dropdown.Item className="dropdown-item" href="#">Tara Misu</Dropdown.Item>
                                                <Dropdown.Item className="dropdown-item" href="#">Midge Itz</Dropdown.Item>
                                                <Dropdown.Item className="dropdown-item" href="#">Sal Vidge</Dropdown.Item>
                                                <Dropdown.Item className="dropdown-item" href="#">Other</Dropdown.Item>
                                            </Dropdown.Menu> */}
                                        </Dropdown>
                                    </div>
                                </div>
                                <div className="total-comment-block">
                                    <Dropdown>
                                        <div as={CustomToggle} id="post-option" style={{color:"black"}}>
                                            {comments?.allComments.length} {t("comments")}
                                        </div>
                                        {/* <Dropdown.Menu className="dropdown-menu">
                                            <Dropdown.Item className="dropdown-item" href="#">Max Emum</Dropdown.Item>
                                            <Dropdown.Item className="dropdown-item" href="#">Bill Yerds</Dropdown.Item>
                                            <Dropdown.Item className="dropdown-item" href="#">Hap E. Birthday</Dropdown.Item>
                                            <Dropdown.Item className="dropdown-item" href="#">Tara Misu</Dropdown.Item>
                                            <Dropdown.Item className="dropdown-item" href="#">Midge Itz</Dropdown.Item>
                                            <Dropdown.Item className="dropdown-item" href="#">Sal Vidge</Dropdown.Item>
                                            <Dropdown.Item className="dropdown-item" href="#">Other</Dropdown.Item>
                                        </Dropdown.Menu> */}
                                    </Dropdown>
                                </div>
                            </div>
                            {/* <ShareOffcanvas /> */}
                        </div>
                        <hr />
                        <ul className="post-comments p-0 m-0">
                            {
                                comments?.allComments?.slice(0, 3).map((i) =>
                                    <li className="mb-2">
                                        <div className="d-flex">
                                            <div className="user-img">
                                                <img src={i?.author?.profileImageLink} alt="userimg" className="avatar-35 rounded-circle img-fluid" />
                                            </div>
                                            <div className="comment-data-block ms-3">
                                                <h6>{i?.author?.firstName} {i?.author?.lastName}</h6>
                                                <p className="mb-0">{i?.content}</p>
                                                <div className="d-flex flex-wrap align-items-center comment-activity">

                                                    <span> {moment(i?.timestamp).fromNow()} </span>
                                                </div>
                                            </div>
                                        </div>

                                    </li>
                                )
                            }
                            {
                                show === index &&
                                comments?.allComments?.slice(3, 10000000000).map((i) =>
                                    <li className="mb-2">
                                        <div className="d-flex">
                                            <div className="user-img">
                                                <img src={i?.author?.profileImageLink} alt="userimg" className="avatar-35 rounded-circle img-fluid" />
                                            </div>
                                            <div className="comment-data-block ms-3">
                                                <h6>{i?.author?.firstName} {i?.author?.lastName}</h6>
                                                <p className="mb-0">{i?.content}</p>
                                                <div className="d-flex flex-wrap align-items-center comment-activity">
                                                    {/* <Link to="">like</Link>
                                                <Link to="">reply</Link>
                                                <Link to="">translate</Link> */}
                                                    <span> {moment(i?.timestamp).fromNow()} </span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                )

                            }
                            <button className='bg-white border-0 ' onClick={() => { setShow(show === index ? null : index) }}>{comments?.allComments?.length > 3 && (show === index ? 'Show Less' : 'Show More')}</button>
                        </ul>
                        <form className="comment-text d-flex align-items-center mt-3" action="" onSubmit={(e) => handleAddComments(e, data?._id)}>
                            <input type="text"
                                className="form-control rounded"
                                placeholder="Enter Your Comment"
                                value={content}
                                onChange={(e) => handleChange(e)}
                                style={{ paddingRight: "40px" }}
                                disabled={loadingComment}
                            />
<button type="submit" style={{ position: "absolute", right: "10px", background: "none", border: "none", cursor: loadingComment ? "not-allowed" : "pointer" }} disabled={loadingComment}>
        <AiOutlineSend size={24} color={loadingComment ? "gray" : "#007bff"} />
    </button>
                        </form>
                    </div>
                </div>

            </Card.Body>
            <ShareToFeedPopup show={showPopup} handleClose={() => setShowPopup(false)} postData={feedData} />
            <Modal
                size="sm"
                className="fade"
                id="qr-modal"
                onHide={closeQrPopup}
                show={qrPopupOpen}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t("qr_code")}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                <div style={{display:"flex", flexDirection:"column", justifyContent:"center"}}>
          <img
            src={qrImageUrl?.qrCodeUrl}
            alt="QR Code"
            style={{ maxWidth: "100%", height: "auto" }}
          />
<span style={{fontSize:"18px", fontWeight:"600"}}>{qrImageUrl?.postUID}</span>
<span style={{fontSize:"10px", fontWeight:"300"}}>www.dirido.com</span>          </div>
          <button className="btn btn-primary mt-3" onClick={downloadQR}>
        {t("download_qr_code")}
      </button>
                </Modal.Body>
                {/* <Modal.Footer>
                    <button
                        className="btn btn-secondary"
                        onClick={closeQrPopup}
                    >
                        Close
                    </button>
                </Modal.Footer> */}
            </Modal>
            <Modal
                size="md"
                className="fade"
                id="report-modal"
                onHide={closeReportModal}
                show={reportModalOpen}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t("reportPost")}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "450px", overflowY: "auto" }}>
                    <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0 ">
                        <li className="col-12 ">
                            <Form.Group className="form-group">
                                <Form.Label>{t("whatAreYouReporting")}?</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={reportDescription}
                                    onChange={(e) => setReportDescription(e.target.value)}
                                    className="mb-0 py-2"
                                    id=""
                                    placeholder={t("reportIssue")}
                                    required
                                />
                            </Form.Group>
                        </li>
                    </ul>

                    <button
                        type="submit"
                        className="btn btn-primary d-block w-100 mt-3"
                        onClick={handleReport}
                    >
                        {t("report")}
                    </button>
                </Modal.Body>
            </Modal>

            <Modal
                                                        size="md"
                                                        className="fade"
                                                        id="post-modal"
                                                        onHide={handleCloseDelete}
                                                        show={showDelete}
                                                        centered
                                                        style={{ marginTop: "100px", maxHeight: "80vh" }}
                                                      >
                                                        <Modal.Header className="d-flex justify-content-between">
                                                          <Modal.Title id="post-modalLabel">{t('delete_post')}</Modal.Title>
                                                          <Link to="#" className="lh-1" onClick={handleCloseDelete}>
                                                            <span className="material-symbols-outlined">close</span>
                                                          </Link>
                                                        </Modal.Header>
                                                        <Modal.Body>
                                                          <div
                                                            className="d-flex align-items-center"
                                                            style={{ fontSize: "16px" }}
                                                          >
                                                            <p>
                                                              {t('delete_confirm')}
                                                            </p>
                                                          </div>
                                                          <button
                                                            type="submit"
                                                            className="btn btn-primary d-block w-100 mt-0"
                                                            onClick={handleDeletePost}
                                                          >
                                                            {t('delete')}       </button>
                                                        </Modal.Body>
                                                      </Modal>

                                                        <Modal size="lg" className="fade" id="post-modal" onHide={handleCloseEdit} show={showEdit} style={{ marginTop: "100px", maxHeight: "80vh" }}>
                                                                                                          <Modal.Header className="d-flex justify-content-between">
                                                                                                              <Modal.Title id="post-modalLabel">{t('edit')} {t('post')}</Modal.Title>
                                                                                                              <Link to="#" className="lh-1" onClick={handleCloseEdit} >
                                                                                                                  <span className="material-symbols-outlined">close</span>
                                                                                                              </Link>
                                                                                                          </Modal.Header>
                                                                                                          <Modal.Body >
                                                                                                          <div className="d-flex align-items-center">
                                                                                                              <div className="user-img">
                                                                                                                  <img src={`${userData?.profileImageLink ? userData?.profileImageLink : '/profile.png'}`} alt="user1" className="avatar-60 rounded-circle" />
                                                                                                              </div>
                                                                                                              <form className="post-text ms-3 w-100 " >
                                                                                                                  <input type="text" className="form-control rounded" placeholder="Write something here..." style={{ border: "none" }} value={description}                         
                                                                                              onChange={(e) => setDescription(e.target.value)}/>
                                                                                                              </form>
                                                                                                          </div>
                                                                                                          <hr></hr>
                                                                                                              <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0 ">
                                                                                                                 
                                                                                                                 
                                                                                                                  <li className="col-md-12 mb-2" >
                                                                                                                    
                                                                                                                      <Form.Label>
                                                                                                                      {t('image')}{" "}
                                                                                                                          <span style={{ color: "red" }}>*</span>{" "}
                                                                                                                      </Form.Label>
                                                                                                                      <label
                                                                                                                          htmlFor="file-input"
                                                                                                                          style={{ cursor: "pointer", width: "100%" }}
                                                                                                                      >
                                                                                                                          <div
                                                                                                                              className="bg-soft-primary rounded p-1 pointer"
                                                                                                                              style={{
                                                                                                                                  width: "100%",
                                                                                                                                  textAlign: "center",
                                                                                                                                  fontSize: "1.2rem",
                                                                                                                                  position: "relative",
                                                                                                                                  borderRadius: "10px",
                                                                                                                              }}
                                                                                                                          >
                                                                                                                              <input
                                                                                                                                  id="file-input"
                                                                                                                                  type="file"
                                                                                                                                  name="image"
                                                                                                                                  multiple
                                                                                                                                  style={{ display: "none" }}
                                                                                                                                  onChange={handleFileInputChange}
                                                                                                                              />
                                                                                                                              <span>
                                                                                                                                  {
                                                                                                                                      selectedFile.length > 0 ?
                                                                                                                                          <MdOutlineDone style={{ fontSize: '25px' }} />
                                                                                                                                          :
                                                                                                                                          <i className="fas fa-upload"></i>
                                                                                                                                  }
                                                                                                                              </span>
                                                                                                                              <p style={{ marginTop: ".5rem" }}>
                                                                                                                                  {t('click_to_select_files')}
                                                                                                                              </p>
                                                                                                                          </div>
                                                                                                                      </label>
                                                                   {/* {imagePreview && imagePreview.length > 0 && (
                                                                                              <div className="mt-2">
                                                                                                  {imagePreview.map((preview, index) => (
                                                                                                      <img key={index} src={preview} alt={`Selected ${index}`} style={{ width: '70px', borderRadius: '10px', marginBottom: '10px' }} />
                                                                                                  ))}
                                                                                              </div>
                                                                                          )} */}
                                                                  {imagePreview && imagePreview.length > 0 && (
                                                          <div className="mt-2 d-flex flex-wrap">
                                                            {imagePreview && imagePreview.length > 0 && (
                                                          <div className="mt-2 d-flex flex-wrap">
                                                              {imagePreview.map((preview, index) => (
                                                                  <div key={index} style={{ position: 'relative', margin: '5px' }}>
                                                                      <img 
                                                                          src={preview} 
                                                                          alt={`Selected ${index}`} 
                                                                          style={{ width: '70px', borderRadius: '10px' }} 
                                                                      />
                                                                      <span 
                                                                          onClick={() => handleRemoveImage(index)} 
                                                                          style={{
                                                                              position: 'absolute',
                                                                              top: '-5px',
                                                                              right: '-5px',
                                                                              background: 'red',
                                                                              color: 'white',
                                                                              borderRadius: '50%',
                                                                              cursor: 'pointer',
                                                                              padding: '2px 5px',
                                                                              fontSize: '12px'
                                                                          }}
                                                                      >
                                                                          ✖
                                                                      </span>
                                                                  </div>
                                                              ))}
                                                          </div>
                                                      )}
                                                      
                                                          </div>
                                                      )}
                                                      
                                                                                                                  </li>
                                                                                                
                                                                  
                                                                                                              </ul>
                                                                  
                                                                                                                          <button type="submit" className="btn btn-primary d-block w-100 mt-0" onClick={handlePost}>{t('post')}</button>
                                                                                                          </Modal.Body>
                                                                                                      </Modal>
        </>
    )
}

export default GroupCardBody
